import { omit } from 'lodash'
import { admin2 } from '@/api/instance'

// POST admin.imageGenerationTask.create
/**
 * 創建圖片生成任務
 * @param {Object} data - 創建資料
 * @param {string} data.shopId - 店家 ID
 * @param {string} data.prompt - 生成提示詞
 * @param {string} [data.style] - 圖片風格
 * @param {string} [data.size] - 圖片尺寸
 * @param {number} [data.quantity] - 生成數量
 * @param {Object} [data.config] - 生成設定
 * @param {string} [data.model] - 使用模型
 * @param {string} [data.quality] - 圖片品質
 */
export const CreateImageGenerationTask = async (data) => {
  return admin2({
    method: 'POST',
    url: `/${data.shopId}/imageGenerationTask`,
    data: omit(data, ['shopId']),
  })
}

// GET admin.imageGenerationTask.findOne
/**
 * 取得單一圖片生成任務
 * @param {Object} params - 查詢參數
 * @param {string|number} params.id - 任務 ID
 * @param {string} params.shopId - 店家 ID
 */
export const FindOneImageGenerationTask = async ({ id, shopId }) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/imageGenerationTask/${id}`,
  })
}
